import React, { Component, useState, useEffect } from "react";
import { ColorModeContext, useMode } from "./assets/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Topbar from "./layouts/Topbar";
import AppRoutes from "./AppRoutes";
import Sidebar from "./layouts/Sidebar";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
  useMsalAuthentication,
  useAccount,
  useMsal,
} from "@azure/msal-react";
import {
  InteractionType,
  PublicClientApplication,
  EventType,
} from "@azure/msal-browser";
import RequestInterceptor from "./auth/RequestInterceptor";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LicenseInfo } from "@mui/x-license-pro";
import saveUserToDatabase from "./components/User/saveUserToDatabase";
import { IntlProvider } from 'react-intl';
import { useSelector } from "react-redux";
LicenseInfo.setLicenseKey(
  "168d6d7cfa6d3e3bb2ee871c640e1e6eTz0xMDc4OTIsRT0xNzcxMTEzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);
const queryClient = new QueryClient({});
function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [userRoles, setUserRoles] = useState([]);
  useMsalAuthentication(InteractionType.Redirect);
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);


  const defaultLocale = useSelector((state) => state.language.language);

  const messages = require(`./translations/${defaultLocale}.json`) // en.json 
  const locale = defaultLocale
  console.log(locale);
  // useEffect(() => {
  //   axios.get("/api/user").then((response) => {
  //     setUserRoles(response.data);
  //   }).catch((error) => console.log(error));
  // }, []);

  // const msalInstance = usems

  instance.addEventCallback((message) => {
    // Update UI or interact with EventMessage here
    if (message.eventType === EventType.LOGIN_SUCCESS) {
      console.log(message.payload);
    }
  });
  // saveUserToDatabase(account);

  return (
    <IntlProvider
    locale={locale}
    messages={messages}
>
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthenticatedTemplate>
          <QueryClientProvider client={queryClient}>
            <RequestInterceptor>
              <div className="app">
              <Sidebar isSidebar={isSidebar} />
              <ToastContainer />
                {/*  */}

                <main className="content">

                  <Topbar />

                  <Routes>
                    {AppRoutes.map((route, index) => {
                      const { element, ...rest } = route;
                      return <Route key={index} {...rest} element={element} />;
                    })}
                    
                  </Routes>
                </main>
              </div>
              <ReactQueryDevtools initialIsOpen={false} />
            </RequestInterceptor>
          </QueryClientProvider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <p> You are not signed in! Please sign in.</p>
        </UnauthenticatedTemplate>
      </ThemeProvider>
    </ColorModeContext.Provider>
    </IntlProvider>
  );
}

export default App;
